import './modal.scss';

import React from 'react';

const Modal = ({title, children}) => {
  return (
    <div
      className="modal"
    >
      <div className="modal-header">
        {title && <h3 className="modal-title">{title}</h3>}
        <div className="modal-close">x</div>
      </div>
      <div className="modal-body">
        {children}
      </div>
      <div className="modal-footer">
        <button
          className="btn col-6"
          type="button"
          onClick={() => {
            onCloseModal();
          }}
        >
          Cancel
        </button>
        <button
          className="btn col-6"
          type="button"
          onClick={() => {
            onSaveModal();
          }}
        >
          Save
        </button>
      </div>
    </div>
  );
};

export default Modal;